module.exports = __webpack_public_path__ + "static/media/jacket.e4c3fccb.jpg";